import {testIdProps} from '@github-ui/test-id-props'
import {clsx} from 'clsx'
import type {ReactNode} from 'react'

import {identity} from '../../../../../utils/identity'
import styles from './iteration-diff-value.module.css'

type DiffValueProps = {
  originalValue?: string
  /** Custom render function for the original value. */
  renderOriginalValue?: (value: string) => ReactNode
  updatedValue?: string
  /** Custom render function for the updated value. */
  renderUpdatedValue?: (value: string) => ReactNode
  testId?: string
  className?: string
}

export const DiffValue = ({
  originalValue = '',
  updatedValue = '',
  renderUpdatedValue = identity,
  renderOriginalValue = identity,
  className,
  testId,
}: DiffValueProps) => {
  return (
    <span className={clsx(styles.Text, className)} {...(testId ? testIdProps(testId) : {})}>
      {originalValue === updatedValue ? (
        <span>{renderUpdatedValue(updatedValue)}</span>
      ) : (
        <>
          {originalValue && (
            <del className={styles.Text_1} {...testIdProps('original-value')}>
              {renderOriginalValue(originalValue)}
            </del>
          )}
          {originalValue && updatedValue && <span className={styles.Text}> </span>}
          {updatedValue && (
            <ins className={styles.Text_2} {...testIdProps('updated-value')}>
              {renderUpdatedValue(updatedValue)}
            </ins>
          )}
        </>
      )}
    </span>
  )
}

try{ DiffValue.displayName ||= 'DiffValue' } catch {}